<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-card v-if="isLoggedIn && role.indexOf('Global Support Manager') > -1">
            <v-card-text>
              <auto-select
                :items="brokers"
                :label="$t('views.tags.select_broker')"
                prepend-icon="supervised_user_circle"
                :loading="loading"
                item-text="Name"
                item-value="Id"
                :value.sync="broker"
              ></auto-select>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";

export default {
  name: "select-broker",
  components: {
    ErrorHandler,
    AutoSelect
  },
  data() {
    return {
      broker: undefined,
      loading: false,
      brokers: [],
      error: null,
      selected: [],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    broker: {
      async handler(v) {
        //console.log(v);
        if (v) {
          this.$router.push({ name: this.$route.params.route, params: { broker: v.Id } });
        }
      },
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.brokers = (await this.getOrganizations()).data.value;
      this.loading = false;
      // if (this.brokers.length === 1) {
      //  this.broker = this.brokers[0] ;
      // }
    } catch (error) {
      this.error = error;
    }
  },
  methods: {
    ...mapActions("applicationUsers", ["getOrganizations"]),
    ...mapActions("auth", ["getRoles", "getUser"]),
  },
};
</script>
